<!--Load the font icons package:-->
<!-- <link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" /> -->

<!-- <kendo-dialog-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    <span class="k-icon k-font-icon k-icon-xl k-i-form-element"></span> {{title}}
  </div>
</kendo-dialog-titlebar> -->

<!-- <kendo-window-titlebar>
  <span class="k-window-title"><fa-icon icon="code-merge"></fa-icon> {{title}}</span>
  <button kendoWindowCloseAction></button>
</kendo-window-titlebar> -->
<div class="container-fluid">
<form [formGroup]="form" (ngSubmit)="onSaveAction()" class="k-form-inline">

    <!-- <div class="row k-form-field">
        <label for="project_name" class="form-label k-label col-5">Project</label>
        <div class="col-7">
            <kendo-dropdownlist [data]="projects" [(value)]="currentProject" textField="project_name"
            valueField="id" (valueChange)="projectValueChange($event)" [valuePrimitive]="true"
            [defaultItem]="defaultProjectItem" formControlName="project_id"></kendo-dropdownlist>
        <div *ngIf="project_id?.invalid" class="alert alert-danger">
            <div *ngIf="project_id?.errors?.['required']">Project is required.</div>
        </div>
        </div>
    </div> -->

    <div class="row k-form-field">
        <label class="form-label k-label col-4" for="comment">Comment/Git Version Number</label>
        <div class="col-5">
        <input appAutoFocus type="text" id="comment" formControlName="comment" class="form-control">
        <div *ngIf="comment?.invalid" class="alert alert-danger">
            <div *ngIf="comment?.errors?.['required']">Comment/Git Version Number is required.</div>
        </div>
        </div>
    </div>

    <div class="row k-form-field">
        <label for="released_by_user_id" class="form-label k-label col-4">Released by User</label>
        <div class="col-5">
            <kendo-dropdownlist [data]="users" textField="fullName" valueField="user_id"
            (valueChange)="userValueChange($event)" [valuePrimitive]="true"
            [defaultItem]="defaultProjectItem" formControlName="released_by_user_id"></kendo-dropdownlist>
        <div *ngIf="released_by_user_id?.invalid" class="alert alert-danger">
            <div *ngIf="released_by_user_id?.errors?.['required']">Released by User is required.</div>
        </div>
        </div>
    </div>

    <div class="row k-form-field">
        <label for="release_date" class="form-label k-label col-4">Release Date</label>
        <div class="col-5">
            <kendo-datepicker
          formControlName="release_date"
          [min]="minDate"
          [max]="maxDate"
          format="dd/MM/yyyy"
        ></kendo-datepicker>
        <div *ngIf="release_date?.invalid" class="alert alert-danger">
            <div *ngIf="release_date?.errors?.['required']">Release Date is required.</div>
        </div>
        </div>
    </div>

    <input type="hidden" formControlName="selectedStoryIds">

</form>

<kendo-grid *ngIf="mode == FormModes.NEW" [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true" [groupable]="true" [resizable]="true"
  [filter]="filter" filterable="menu" (filterChange)="filterChange($event)" (sortChange)="sortChange($event)"
  [pageSize]="pageSize" [pageable]="{
    buttonCount: buttonCount,
    previousNext: previousNext,
    info: info
  }" [height]="500" [loading]="loading">

  <ng-template kendoGridToolbarTemplate position="top">
    
    <button (click)="toggleAll()" kendoButton class="btn btn-primary">
        <span *ngIf="toggleFlag">Un</span>Select All
    </button>
    
  </ng-template>

  <kendo-grid-column title="Select" [width]="60" >
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <input type="checkbox" kendoCheckBox size="large" [checked]="dataItem.selected"
              (click)="setSelection(dataItem)" />
      <!-- <button (click)="onEditClick(dataItem, windowTitleBar)" [hidden]="!canUpdate" kendoButton
        class="btn btn-stn-grid">
        <fa-icon icon="edit"></fa-icon>
      </button> -->
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="title" title="Title" [width]="260" >
    <ng-template kendoGridCellTemplate let-dataItem>
      <div [innerHTML]="formatText(dataItem.title)"></div>
    </ng-template>
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="user_story_priority_description" title="Priority" [width]="120">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div
        [ngClass]="{'priority-low': dataItem.user_story_priority_description?.toLowerCase().indexOf('low') != -1
        , 'priority-medium': dataItem.user_story_priority_description?.toLowerCase().indexOf('medium') != -1 
        , 'priority-high': dataItem.user_story_priority_description?.toLowerCase().indexOf('high') != -1
        , 'priority-critical': dataItem.user_story_priority_description?.toLowerCase().indexOf('critical') != -1 }">
        {{dataItem.user_story_priority_description}}
    </div>
    </ng-template>
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="user_story_type_description" title="Type" [width]="120" >
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="owned_by_users" title="Owners" [width]="120" >
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
      let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="requested_by_user" title="Requested By" [width]="150" >
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="user_story_estimate_description" title="Estimate" [width]="100">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

</kendo-grid>

<kendo-dialog-actions>
  <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="form.invalid || (mode == FormModes.NEW && selectedStoryIds.length == 0)">
    Save
  </button>
  <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
</kendo-dialog-actions>

</div>